import {
  IconClock,
  IconPencil,
  IconTrash,
  IconMailForward,
} from "@tabler/icons-react";
import { getInitials, colourForName, formatLoginShort } from "./data";
import styles from "../../pages/ClientDashboard/TeamManagement/teamManagement.module.css";
import Button from "../UI/Button/button";
import RoleBadge from "./RoleBadge";
import PendingBadge from "./PendingBadge";

export default function UsersMobileList({
  users,
  currentUserId,
  canActOn,
  onEditUser,
  onRemoveUser,
  onResendInvite,
}) {
  return (
    <div className={styles.userMobileList}>
      {users?.map((u) => {
        const colour = colourForName(u.name);
        const isSelf = u?._id === currentUserId;
        const manageable = canActOn(u);
        const canEdit = isSelf || manageable;
        const canRemove = manageable && !isSelf && !u.isOwner;
        const canResend = manageable && u?.status === "pending";

        return (
          <div key={u?._id} className={styles.userMobileItem}>
            <div className={styles.umlAvatar} style={{ background: colour }}>
              {getInitials(u.name)}
            </div>

            <div className={styles.umlBody}>
              <div className={styles.umlName}>{u?.name}</div>
              <div className={styles.umlEmail}>{u?.email}</div>
              <div className={styles.umlChips}>
                {u?.status === "pending" ? (
                  <PendingBadge />
                ) : (
                  <RoleBadge role={u?.role} />
                )}
                {u?.teamId && (
                  <span
                    className={`${styles.teamChip} ${styles.umlChipSmall}`}
                    style={
                      u?.teamId?.colour
                        ? {
                            background: `${u?.teamId?.colour}1a`,
                            color: u?.teamId?.colour,
                          }
                        : undefined
                    }
                  >
                    {u?.teamId?.name}
                  </span>
                )}
              </div>
              <div className={styles.umlLogin}>
                <IconClock size={12} />
                {u?.lastLogin
                  ? formatLoginShort(u?.lastLogin)
                  : "Never logged in"}
              </div>
            </div>

            <div className={styles.umlActions}>
              {canResend && (
                <Button
                  variant="icon"
                  size="sm"
                  className={styles.rowIconBtn}
                  aria-label="Resend invite"
                  onClick={() => onResendInvite(u?._id)}
                >
                  <IconMailForward size={15} />
                </Button>
              )}
              {canEdit && (
                <Button
                  variant="icon"
                  size="sm"
                  className={styles.rowIconBtn}
                  aria-label="Edit"
                  onClick={() => onEditUser(u?._id)}
                >
                  <IconPencil size={15} />
                </Button>
              )}
              {canRemove && (
                <Button
                  variant="icon"
                  size="sm"
                  className={`${styles.rowIconBtn} ${styles.rowIconDanger}`}
                  aria-label="Remove"
                  onClick={() => onRemoveUser(u?._id)}
                >
                  <IconTrash size={15} />
                </Button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
